<template>
  <div id="index_div" style="width:100%;"> <!-- position: relative; -->
    <router-view @showHistory='showHistoryModel'>
     
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return { flag: true }
  },
  methods: {
    showHistoryModel() {
      console.log('showHistoryModel')
      this.$emit('showHistory')
    }
  }
}
</script>


<style scoped>
</style>
